import { render, staticRenderFns } from "./UploadOpus.vue?vue&type=template&id=a3e5ae10&scoped=true&"
import script from "./UploadOpus.vue?vue&type=script&lang=js&"
export * from "./UploadOpus.vue?vue&type=script&lang=js&"
import style0 from "./UploadOpus.vue?vue&type=style&index=0&id=a3e5ae10&prod&scoped=true&lang=less&"
import style1 from "./UploadOpus.vue?vue&type=style&index=1&id=a3e5ae10&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e5ae10",
  null
  
)

export default component.exports